import { PreviewAccessRequestModel } from '@capturi/core'
import { usePreviewAccess } from '@capturi/sharing'
import { t } from '@lingui/macro'
import { useMemo } from 'react'

const getPreviewAccessWarningText = (
  previewAccessResponse: string | undefined,
): string | undefined => {
  switch (previewAccessResponse) {
    case 'NoAccess':
      return t`*You will no longer be able to view the questionnaire when you apply`
    case 'Editable':
      return undefined
    case 'Viewable':
      return t`*You will no longer be able to edit the questionnaire when you apply because you set your own permission to "viewer"`
  }
}

const questionnairePreviewAccessRequest = (
  previewAccessRequestModel: PreviewAccessRequestModel,
) => {
  return {
    url: 'questionnaires/preview-access',
    method: 'post',
    json: previewAccessRequestModel,
  }
}

export const useQuestionnairePreviewAccess = (
  previewAccessRequestModel: PreviewAccessRequestModel,
) => {
  const { previewAccessResponse, validationError } = usePreviewAccess({
    previewAccessRequestModel,
    createPreviewAccessRequest: questionnairePreviewAccessRequest,
  })

  return useMemo(
    () => ({
      previewAccessWarningText: getPreviewAccessWarningText(
        previewAccessResponse,
      ),
      validationError,
    }),
    [previewAccessResponse, validationError],
  )
}
